import React, { useState } from 'react';
import get from 'lodash/get';
import omit from 'lodash/omit';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons/faEyeSlash';
import { faFileAlt } from '@fortawesome/free-regular-svg-icons/faFileAlt';

import { env, lang } from '~/commons/config';
import ListResource from './ListResource.jsx';
import ListCtrlActivates from './ListCtrlActivates.jsx';
import ListCompSelect from './ListCompSelect.jsx';

const api = 'api/core/users/students';

const ListStudents = (props) => {
  const { school, deactivateAll } = props;
  const [compFilter, setCompFilter] = useState({});

  const filter = { ...compFilter };

  if (school) filter.school = school;

  return (
    <ListResource
      {...{
        searchable: [
          { value: 'name', label: 'Name' },
          { value: 'schoolClass.title', label: 'Class' },
          {
            value: 'schoolClass.grade',
            label: 'Grade',
            options: Object.keys(env.grades).map((g) => ({
              value: g,
              label: env.grades[g].zhhk,
            })),
          },
          { value: 'studentId', label: 'Class No.' },
        ],
        api,
        sort: { 'name.full.en': 1 },
        filter,
        actions: {
          create: school !== undefined,
          fileExport: true,
          fileImport: { url: 'api/core/users/batch/import' },
        },
        ctrls: [
          <ListCompSelect
            key={0}
            value={compFilter}
            onChange={setCompFilter}
            questionSet
          />,
        ],
        cols: [
          {
            key: 'name.full.en',
            children: 'Name',
            sortable: true,
            getter: (v, r) => lang(r.name.full),
          },
          {
            key: 'studentId',
            children: 'Class No.',
            sortable: true,
          },
          {
            key: 'active',
            getter(v) {
              return (
                <FA icon={v ? faEye : faEyeSlash} />
              );
            },
          },
          {
            key: 'lv',
            children: 'Group',
            sortable: true,
            getter: (v) => get(env.lvs, `${v}.zhhk`),
          },
          ...(!school ? [
            {
              key: 'school.title.en',
              children: 'School',
              getter: (v, r) => lang(get(r, 'school.title')),
            },
          ] : []),
          {
            key: 'schoolClass.acadYear',
            children: 'Year',
            getter: (v) =>  v?`${v}/${v+1}` : ""
          },
          {
            key: 'schoolClass.grade',
            children: 'Grade',
            getter: (v) => get(env.grades, `${v}.zhhk`),
          },
          {
            key: 'schoolClass.title',
            children: 'Class',
          },
        ],
        ...omit(props, 'school'),
      }}
    >
      {({ selected, refresh }) => (
        <>
          <ListCtrlActivates
            api={api}
            deactivateAll={deactivateAll}
            selected={selected}
            onSuccess={refresh}
          />
          <a
            className="btn btn-link"
            href={'api/core/users/batch/import-example'}
          >
            <FA icon={faFileAlt} fixedWidth />
            &nbsp;
            Import template
          </a>
        </>
      )}
    </ListResource>
  );
};

export default ListStudents;
